import { useCallback } from 'react';

import { useCreatePintoWriterCampaignMutation } from '../core/graphql/operation-hooks';
import { CreatePintoProductCampaignInput } from '../core/graphql/types';

const useMutationCreatePintoWriterCampaign = () => {
  const [mutateCreatePintoWriterCampaign, { loading: isLoadingMutateCreatePintoWriterCampaign }] = useCreatePintoWriterCampaignMutation();

  const onMutateCreatePintoWriterCampaign = useCallback(
    (input: CreatePintoProductCampaignInput) => {
      const variables = { input };
      return mutateCreatePintoWriterCampaign({ variables });
    },
    [mutateCreatePintoWriterCampaign],
  );

  return {
    onMutateCreatePintoWriterCampaign,
    isLoadingMutateCreatePintoWriterCampaign,
  };
};

export default useMutationCreatePintoWriterCampaign;
